let FUNCTION_API_ENDPOINT = 'https://us-central1-chameleon-isb.cloudfunctions.net/api';
if (window.location.hostname === 'localhost') {
  FUNCTION_API_ENDPOINT = 'http://localhost:5001/chameleon-isb/us-central1/api';
}

export {
  FUNCTION_API_ENDPOINT
};

